import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MediaDelete } from "../../apis/api/GalleryApis";
import Cookies from "js-cookie";

const PhotoGallery = () => {
  const [Photodata, setPhotodata] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  const [photoToDelete, setPhotoToDelete] = useState(null);
  const company_id = Cookies.get("company_id");
  const UserID = Cookies.get("userID");
  const { media } = useSelector((state) => state.GallerySlice);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (media?.result?.length > 0) {
      const photoItems = media.result.filter(
        (item) => item.extension_type === "image"
      );
      setPhotodata(photoItems);
    }
  }, [media]);

  const handleImageClick = (photo) => {
    setSelectedPhoto(photo);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedPhoto(null);
  };

  const handleDelete = async (id) => {
    const updatedPhotos = Photodata.filter((photo) => photo.id !== id);
    setPhotodata(updatedPhotos);
    await dispatch(MediaDelete({ id }));
  };

  return (
    <div className="bg-white" style={{ height: "85vh"}}>
    <div className="row p-3">
  {Photodata && Photodata.length > 0 ? (
    Photodata.map((photo, index) => (
      <div key={photo.id || index} className="col-md-4 col-lg-3 col-12 mb-4">
        <div
          className="position-relative border rounded shadow-sm p-3 d-flex flex-column justify-content-between transition"
          style={{ transition: "transform 0.3s ease", backgroundColor: "#f8f9fa", cursor: "pointer" }}
          onClick={() => handleImageClick(photo)}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          {UserID === photo?.member_id && company_id === photo?.company_id && (
            <button
              className="btn btn-sm btn-danger position-absolute top-0 end-0 m-2"
              onClick={(e) => {
                e.stopPropagation(); // prevent triggering image click
                setPhotoToDelete(photo.id);
                setDeleteConfirmModal(true);
              }}
            >
              <i className="bx bx-trash"></i>
            </button>
          )}

          <img
            src={photo.file_url.replace("/thumb", "")}
            alt={photo.tittle}
            className="img-fluid rounded w-100"
          />
          <h6 className="mt-2 text-center">{photo.tittle}</h6>
        </div>
      </div>
    ))
  ) : (
    <p className="text-center">No photos available.</p>
  )}
</div>


      {/* View Image Modal */}
      {selectedPhoto && (
        <div
          className={`modal fade show ${showModal ? "d-block" : ""}`}
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{selectedPhoto?.tittle}</h5>
                <button type="button" className="btn-close" onClick={handleClose}></button>
              </div>
              <div className="modal-body text-center">
                <img
                  src={selectedPhoto?.file_url.replace("/thumb", "")}
                  alt={selectedPhoto?.tittle}
                  className="img-fluid rounded"
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {deleteConfirmModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setDeleteConfirmModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this photo?</p>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setDeleteConfirmModal(false)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-danger"
                  onClick={() => {
                    handleDelete(photoToDelete);
                    setDeleteConfirmModal(false);
                  }}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PhotoGallery;
